import React from "react";
import ShiftbatItems from "../components/ShiftbatItems";

export default function ShiftbatList(...props) {
    return (
        <div className="Courses">
            <div className="AppContainer">
                <h1 className="SectionTitle">Driver Duties</h1>
                <ShiftbatItems />
            </div>
        </div>
    );
}
